<template>
    <div class="web">
        <Header :type="'empresas'"></Header>
        <main class="empresa">

            <!-- Y como empresa, ¿qué te ofrecemos al unirte a itSAPp? -->
            <div class="container my-5 empresa-top">
                <div class="d-flex flex-row">
                    <div class="col-lg-7 pe-0 flex-grow">
                        <div class="col-lg-12 d-flex justify-content-center align-items-center mb-4">
                            <div class="col-8">
                                <h2 class="strong text-grey mb-4 text-center"> ¿Qué <span
                                        class="bg-blue px-3">ofrecemos</span> al unirte a it<span class="text-orange">SAP</span>p como
                                        <span class="bg-blue px-3">empresa?</span></h2>
                            </div>
                            <div class="col-4 position-relative text-center">
                                <img  class="icons" :src="urlWeb + '/assets/images/logos/icon- lap top.png'">
                            </div>
                        </div>
                        <div class="col-lg-12 d-flex justify-content-center align-items-center mb-4">
                            <div class="col-4 position-relative text-center mr-3">
                                <img class="icons" :src="urlWeb + '/assets/images/logos/money-grow.png'" >
                            </div>
                            <div class="bg-blue py-2 px-4">
                                <p class="font-medium">En el mundo actual, la demanda de servicios de consultoría en
                                    tecnologías de SAP está
                                    en constante crecimiento. En itSAPp, ofrecemos una opción innovadora para mantener
                                    la competitividad y rentabilidad en tu empresa.</p>
                            </div>
                        </div>
                        <div class="col-lg-12 d-flex justify-content-center align-items-center mb-4">
                            <div class="col-8 py-2 px-4">
                                <p class="font-medium">Al unirte a nuestra comunidad, tendrás acceso directo a consultores
                                    independientes de
                                    todo el mundo, expertos en los productos de SAP, listos para ejecutar proyectos, ya sean
                                    pequeños o medianos, simples o complejos.</p>
                            </div>
                            <div class="col-4 position-relative text-center">
                                <img  class="icons" :src="urlWeb + '/assets/images/logos/tablet.png'">
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-5 d-flex flex-column align-items-end">
                        <div class="">
                            <img class="img-fluid" :src="urlWeb + '/assets/images/fotos/24.png'" alt="Imagen escritorio empresa junta">
                        </div>
                        <div class="col-8 offset-lg-4 py-lg-4">
                            <p class="text-justified font-medium">Cubrir los requerimientos del negocio,
                                atender las peticiones de los usuarios y mantener una
                                cultura innovadora focalizada en la mejora continua de tus aplicaciones SAP son aspectos
                                fundamentales para el éxito de tu empresa</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Videos Empresas -->
            <div class="container mb-5">
                <div class="row">
                    <div class="col-12">
                        <h1 class="text-grey strong text-center">¡Te contamos <span class="bg-blue px-3">algunas
                                historias!</span></h1>
                    </div>

                    <!-- Videos Español -->
                    <div class="d-flex flex-row">
                        <div class=" p-5">
                            <div>
                                <div>
                                    <iframe width="100%"
                                        src="https://www.youtube.com/embed/EcvA5AzC1C4?si=AgqMwSklh_W3m7tb"
                                        title="YouTube video player" frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowfullscreen
                                        ></iframe>
                                </div>
                                
                            </div>
                        </div>
                        <div class="p-5">
                            <div >
                                <div>
                                    <iframe width="100%"
                                        src="https://www.youtube.com/embed/Vr8ibqDgKrg?si=XsPHQEpo_jekL__S"
                                        title="YouTube video player" frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                        <div class="p-5">
                            <div>
                                <div>
                                    <iframe width="100%"
                                        src="https://www.youtube.com/embed/Q68n0E7yMuw?si=cqv0SFw38G3WAC_o"
                                        title="YouTube video player" frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Videos Inglés -->
                    <div class="d-flex flex-row">
                        <div class="p-5">
                            <div>
                                <div>
                                    <iframe width="100%" 
                                        src="https://www.youtube.com/embed/kaoraArovr0?si=0Aw0SMsT2UpPgPCU"
                                        title="YouTube video player" frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                        <div class="p-5">
                            <div>
                                <div>
                                    <iframe width="100%"
                                        src="https://www.youtube.com/embed/NOFBOqMzd5k?si=8RGewIov6xX1MHJy"
                                        title="YouTube video player" frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                        <div class="p-5">
                            <div>
                                <div>
                                    <iframe width="100%"
                                        src="https://www.youtube.com/embed/yqokdPDA2gg?si=NgEJSfCwcFrV6iff"
                                        title="YouTube video player" frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
            </div>

            <!-- ¿Cómo funciona? -->
            <div class="container mb-5">
                <div class="row mb-4">
                    <div class="col-12">
                        <h1 class="strong text-center text-grey">¿Cómo <span class="bg-blue px-3">funciona?</span></h1>
                    </div>
                </div>

                <div class="row">
                    <div class="container">
                        <div class="col-12">
                            <video controls>
                                <source :src="urlWeb+ '/assets/videos/funciona_empresas.mp4'" type="video/mp4">
                            </video>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Separator + Subscribe btn -->
            <div class="container mb-5">
                <div class="row">
                    <div class="col-6">
                        <hr>
                    </div>
                    <div class="col-6 text-center">
                        <router-link to="/Registro" class="btn btn-subscribe-lg">Suscríbete</router-link>
                    </div>
                </div>
            </div>

            <!-- bullets -->
            <div class="container mb-5 py-5 empresa-bottom">
                <div class="d-flex flex-row">
                    <div>
                        <img :src="urlWeb + '/assets/images/fotos/32.png'"
                            alt="Trabajo en equipo desarrollando proyectos">
                    </div>
                    <div class="col-lg-5 d-flex justify-content-center align-items-center flex-column">
                        <h5 class="strong text-center mb-4">Ofrecemos una experiencia libre de riesgos al trabajar con
                            consultores de todo el mundo.</h5>
                        <ul>
                            <li class="font-medium">Comienza hoy y paga solo cuando estés completamente satisfecho con el
                                trabajo.</li>
                            <li class="font-medium">Garantía de cumplimiento total o la devolución de tu dinero.</li>
                            <li class="font-medium">Seguridad en todas las transacciones con pagos protegidos.</li>
                            <li class="font-medium">Siempre sabrás el costo exacto de los servicios contratados.</li>
                        </ul>
                    </div>
                </div>
                <div class="d-flex flex-row">
                    <div class="col-lg-5 d-flex justify-content-center flex-column">
                        <h5 class="strong text-grey text-center my-4">¡Además de estas garantías, al trabajar con nuestra
                            plataforma, también disfrutarás de una serie de beneficios, que incluyen:</h5>
                        <ul class="mt-2">
                            <li class="font-medium">Acceso a miles de consultores en todo el mundo con diversas habilidades y experiencias.</li>
                            <li class="font-medium">Posibilidad de ahorrar hasta un 30% en comparación con los costos que te cobraría una firma
                                de consultores tradicional.</li>
                            <li class="font-medium">Flexibilidad para negociar el monto y las condiciones de las propuestas recibidas para tus
                                proyectos.</li>
                            <li class="font-medium">Libertad para ejecutar proyectos sin limitaciones en cantidad.</li>
                            <li class="font-medium">Acceso al mejor talento del mundo</li>
                        </ul>
                    </div>
                    <div class="col-lg-7 d-flex justify-content-center align-items-center">
                        <img class="img-fluid" :src="urlWeb + '/assets/images/fotos/15.png'" alt="Forma de pago tarjeta de credito">
                    </div>
                </div>
            </div>
            <div class=" text-center pb-5">
                <router-link to="/Registro" class="btn btn-subscribe-lg">Suscríbete</router-link>
            </div>
            <!-- gray separator -->
            <div class="container mb-5 bg-light-grey py-3">
                <div class="row">
                    <div class="col-12">
                        <h5 class="text-orange text-center mb-0">Optimizarás el uso de tu presupuesto de TI y lograrás
                            ahorros del 30% o más.<br />
                            Nuestra plataforma es segura, eficiente y fácil de usar.
                        </h5>
                    </div>
                </div>
            </div>

        </main>
    </div>
  </template>
    
    <script>
    import { mapState } from 'vuex'
    import Header from '@/components/Header'
    export default {
      computed:{
        ...mapState(['urlWeb'])
    },
      name: 'Empresas',
      components:{
        Header
    },
      data () {
        return {
        }
      }
    }
    </script>


// WEBPACK FOOTER //
// src/views/Home/Empresas.vue